import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import i18n from 'app/common/i18n';

import { fetchActivity } from './redux';
import { setTitle } from 'app/layout/redux';

import Loading from 'app/common/Loading';
import Paper from '@mui/material/Paper';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import { styled } from '@mui/material/styles';

const RootPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(3),
  overflowX: 'auto'
}));

const StyledTable = styled(Table)({
  minWidth: 500
});

@connect(({ activity }) => ({ ...activity }), { setTitle })
@i18n
class Activity extends Component {
  static fetchDataDeferred({ dispatch }) {
    return dispatch(fetchActivity());
  }

  static propTypes = {
    loading: PropTypes.bool.isRequired,
    list: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.setTitle(this.props.i18n('Activity'));
  }

  componentWillUnmount() {
    this.props.setTitle();
  }

  render() {
    const { list, loading } = this.props;

    return (
      <div>
        {loading && !list.size ? (
          <Loading />
        ) : (
          <RootPaper>
            <StyledTable>
              <TableHead>
                <TableRow>
                  <TableCell>{this.props.i18n('Action')}</TableCell>
                  <TableCell>{this.props.i18n('Target')}</TableCell>
                  <TableCell>{this.props.i18n('Actor')}</TableCell>
                  <TableCell>{this.props.i18n('Timestamp')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item) => (
                  <TableRow key={item.get('_id')}>
                    <TableCell>{item.get('action')}</TableCell>
                    <TableCell>{item.get('target')}</TableCell>
                    <TableCell>{item.get('actor')}</TableCell>
                    <TableCell>{item.get('timestamp')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </StyledTable>
          </RootPaper>
        )}
      </div>
    );
  }
}

export default Activity;
